import { getData, postData, putData, deleteData } from "../apiClient";

// get vehicles with pagination
export const getVehiclesWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
        });

        const result = await getData(`/vehicle-management/vehicles?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error("Get Vehicle with pagination API error:", error);
        return {
            success: false,
            ...error,
        };
    }
};

// get vehicle data with id
export const getVehicleDataWithId = async (id) => {
    try {
        const result = await getData(`/vehicle-management/vehicle/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Vehicle data API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// create vehicle 
export const createVehicle = async ({ data }) => {
    try {
        const result = await postData(`/vehicle-management/add-vehicle`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Vehicle add API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// update vehicle data
export const updateVehicle = async ({ id, data }) => {
    try {
        const result = await putData(`/vehicle-management/update-vehicle/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Vehicle API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

// delete vehicle
export const deleteVehicle = async ({ id }) => {
    try {
        const result = await deleteData(`/vehicle-management/delete-vehicle/${id}`);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Vehicle API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};
